import DashboardLayout from "../components/Dashboard/Layout/DashboardLayout.vue";
// GeneralViews
import Login from "../components/GeneralViews/Login.vue";
import NotFound from "../components/GeneralViews/NotFoundPage.vue";
import Starter from "../components/GeneralViews/Starter.vue";

// Admin pages

//User Pages
import User from "src/components/Dashboard/Views/Users/User.vue";
import UserCharts from "src/components/Dashboard/Views/Users/UserCharts.vue";
import UserCreate from "src/components/Dashboard/Views/Users/UserCreate.vue";
import UserEdit from "src/components/Dashboard/Views/Users/UserEdit.vue";
import UserList from "src/components/Dashboard/Views/Users/UserList.vue";

// vip
import Vip from "src/components/Dashboard/Views/Vip/Vip.vue";
import VipCreate from "src/components/Dashboard/Views/Vip/VipCreate.vue";
import VipList from "src/components/Dashboard/Views/Vip/VipList.vue";

//Industry Pages
import IndustriesList from "src/components/Dashboard/Views/Industries/IndustriesList.vue";
import Industry from "src/components/Dashboard/Views/Industries/Industry.vue";

//Mining Pages
import Mining from "src/components/Dashboard/Views/Mining/Mining.vue";
import MiningEdit from "src/components/Dashboard/Views/Mining/miningEdit.vue";
import MiningList from "src/components/Dashboard/Views/Mining/miningList.vue";

//Payment Page
import Payment from "src/components/Dashboard/Views/Payment/Payment.vue";
import PaymentCreate from "src/components/Dashboard/Views/Payment/PaymentCreate.vue";
import PaymentEdit from "src/components/Dashboard/Views/Payment/PaymentEdit.vue";
import PaymentList from "src/components/Dashboard/Views/Payment/PaymentList.vue";

//Material Page
import Material from "src/components/Dashboard/Views/Material/Material.vue";
import MaterialCreate from "src/components/Dashboard/Views/Material/MaterialCreate.vue";
import MaterialEdit from "src/components/Dashboard/Views/Material/MaterialEdit.vue";
import MaterialList from "src/components/Dashboard/Views/Material/MaterialList.vue";

//Auction Page
import Auction from "src/components/Dashboard/Views/Auction/Auction.vue";
import AuctionCreate from "src/components/Dashboard/Views/Auction/AuctionCreate.vue";
import AuctionEdit from "src/components/Dashboard/Views/Auction/AuctionEdit.vue";
import AuctionList from "src/components/Dashboard/Views/Auction/AuctionList.vue";

//Category Page
import Category from "src/components/Dashboard/Views/Category/Category.vue";
import CategoryCreate from "src/components/Dashboard/Views/Category/CategoryCreate.vue";
import CategoryEdit from "src/components/Dashboard/Views/Category/CategoryEdit.vue";
import CategoryList from "src/components/Dashboard/Views/Category/CategoryList.vue";

//Type Fuel Page
import TypeFuel from "src/components/Dashboard/Views/TypeFuel/TypeFuel.vue";
import TypeFuelCreate from "src/components/Dashboard/Views/TypeFuel/TypeFuelCreate.vue";
import TypeFuelEdit from "src/components/Dashboard/Views/TypeFuel/TypeFuelEdit.vue";
import TypeFuelList from "src/components/Dashboard/Views/TypeFuel/TypeFuelList.vue";

//Colors Page
import Colors from "src/components/Dashboard/Views/Colors/Colors.vue";
import ColorsCreate from "src/components/Dashboard/Views/Colors/ColorsCreate.vue";
import ColorsEdit from "src/components/Dashboard/Views/Colors/ColorsEdit.vue";
import ColorsList from "src/components/Dashboard/Views/Colors/ColorsList.vue";

//Manufacture Page
import Manufacture from "src/components/Dashboard/Views/Manufacture/Manufacture.vue";
import ManufactureCreate from "src/components/Dashboard/Views/Manufacture/ManufactureCreate.vue";
import ManufactureEdit from "src/components/Dashboard/Views/Manufacture/ManufactureEdit.vue";
import ManufactureList from "src/components/Dashboard/Views/Manufacture/ManufactureList.vue";

//Measure Page
import Measure from "src/components/Dashboard/Views/Measure/Measure.vue";
import MeasureCreate from "src/components/Dashboard/Views/Measure/MeasureCreate.vue";
import MeasureEdit from "src/components/Dashboard/Views/Measure/MeasureEdit.vue";
import MeasureList from "src/components/Dashboard/Views/Measure/MeasureList.vue";

//Car Page
import Car from "src/components/Dashboard/Views/Car/Car.vue";
import CarCreate from "src/components/Dashboard/Views/Car/CarCreate.vue";
import CarEdit from "src/components/Dashboard/Views/Car/CarEdit.vue";
import CarList from "src/components/Dashboard/Views/Car/CarList.vue";

//SaleCar Page
import SaleCar from "src/components/Dashboard/Views/SaleCar/SaleCar.vue";
import SaleCarCreate from "src/components/Dashboard/Views/SaleCar/SaleCarCreate.vue";
import SaleCarEdit from "src/components/Dashboard/Views/SaleCar/SaleCarEdit.vue";
import SaleCarList from "src/components/Dashboard/Views/SaleCar/SaleCarList.vue";

//Promotion Page
import Promotion from "src/components/Dashboard/Views/Promotion/Promotion.vue";
import PromotionCreate from "src/components/Dashboard/Views/Promotion/PromotionCreate.vue";
import PromotionEdit from "src/components/Dashboard/Views/Promotion/PromotionEdit.vue";
import PromotionList from "src/components/Dashboard/Views/Promotion/PromotionList.vue";

//Supports Page
import Support from "src/components/Dashboard/Views/Support/Support.vue";
import SupportCreate from "src/components/Dashboard/Views/Support/SupportCreate.vue";
import SupportEdit from "src/components/Dashboard/Views/Support/SupportEdit.vue";
import SupportList from "src/components/Dashboard/Views/Support/SupportList.vue";

//Notifications Page
import NotificationCreate from "src/components/Dashboard/Views/Notifications/NotificationCreate.vue";
import NotificationEdit from "src/components/Dashboard/Views/Notifications/NotificationEdit.vue";
import NotificationList from "src/components/Dashboard/Views/Notifications/NotificationList.vue";
import Notifications from "src/components/Dashboard/Views/Notifications/Notifications.vue";

//Settings Page
import Settings from "src/components/Dashboard/Views/Settings/Settings.vue";
import SettingsEdit from "src/components/Dashboard/Views/Settings/SettingsEdit.vue";

//Password Page
import Password from "src/components/Dashboard/Views/Password/Password.vue";
import PasswordEdit from "src/components/Dashboard/Views/Password/PasswordEdit.vue";

import Home from "src/components/Dashboard/Views/Home.vue";

const routes = [
  {
    path: "/",
    component: Starter,
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/admin",
    component: DashboardLayout,
    redirect: "/admin/home",
    children: [
      {
        path: "home",
        name: "",
        component: Home,
      },
      {
        path: "lojistas",
        name: "lojistas",
        component: Industry,
        redirect: "lojistas/lista",
        children: [
          {
            path: "lista",
            name: "lojistas - Lista",
            component: IndustriesList,
          },
          // {
          //   path: 'editar/',
          //   name: 'advogados - Editar',
          //   component: IndustryEdit
          // },
        ],
      },
      {
        path: "vendedores",
        name: "Auditáveis",
        component: Mining,
        redirect: "Auditáveis - Lista",
        children: [
          {
            path: "lista",
            name: "Auditáveis - Lista",
            component: MiningList,
          },
          {
            path: 'editar/',
            name: 'Auditáveis - Editar',
            component: MiningEdit
          },
        ],
      },
      {
        path: "usuarios",
        name: "Usuários",
        component: User,
        redirect: "usuarios/lista",
        children: [
          {
            path: "lista",
            name: "Usuários - Lista",
            component: UserList,
          },
          {
            path: "grafico",
            name: "Usuários - Gráfico",
            component: UserCharts,
          },
          {
            path: "editar/",
            name: "Usuários - Editar",
            component: UserEdit,
          },
          {
            path: "criar",
            name: "Usuários - Criar",
            component: UserCreate,
          },
        ],
      },
      {
        path: "vip",
        name: "Vip",
        component: Vip,
        redirect: "/admin/vip/lista",
        children: [
          {
            path: "lista",
            name: "Vip - Lista",
            component: VipList,
          },
          {
            path: "criar",
            name: "Vip - Criar",
            component: VipCreate,
          },
        ],
      },
      {
        path: "ofertas",
        name: "Ofertas",
        component: Auction,
        redirect: "leiloes/lista",
        children: [
          {
            path: "lista",
            name: "Ofertas - Lista",
            component: AuctionList,
          },
          {
            path: "editar/",
            name: "Ofertas - Editar",
            component: AuctionEdit,
          },
          {
            path: "criar",
            name: "Ofertas - Criar",
            component: AuctionCreate,
          },
        ],
      },

      {
        path: "promocoes",
        name: "Promoções",
        component: Promotion,
        redirect: "promocoes/lista",
        children: [
          {
            path: "lista",
            name: "Promoções - Lista",
            component: PromotionList,
          },
          {
            path: "editar/",
            name: "Promoções - Editar",
            component: PromotionEdit,
          },
          {
            path: "criar",
            name: "Promoções - Criar",
            component: PromotionCreate,
          },
        ],
      },

      {
        path: "pagamentos",
        name: "Pagamentos",
        component: Payment,
        redirect: "pagamentos/lista",
        children: [
          {
            path: "lista",
            name: "Pagamentos - Lista",
            component: PaymentList,
          },
          {
            path: "editar/",
            name: "Pagamentos - Editar",
            component: PaymentEdit,
          },
          {
            path: "criar",
            name: "Pagamentos - Criar",
            component: PaymentCreate,
          },
        ],
      },

      {
        path: "materiais",
        name: "Materiais",
        component: Material,
        redirect: "materiais/lista",
        children: [
          {
            path: "lista",
            name: "Materiais - Lista",
            component: MaterialList,
          },
          {
            path: "editar/",
            name: "Materiais - Editar",
            component: MaterialEdit,
          },
          {
            path: "criar",
            name: "Materiais - Criar",
            component: MaterialCreate,
          },
        ],
      },
      {
        path: "categorias",
        name: "Categorias",
        component: Category,
        redirect: "categorias/lista",
        children: [
          {
            path: "lista",
            name: "Categorias - Lista",
            component: CategoryList,
          },
          {
            path: "editar/",
            name: "Categorias - Editar",
            component: CategoryEdit,
          },
          {
            path: "criar",
            name: "Categorias - Criar",
            component: CategoryCreate,
          },
        ],
      },
      {
        path: "colors",
        name: "Colors",
        component: Colors,
        redirect: "colors/lista",
        children: [
          {
            path: "lista",
            name: "Cores - Lista",
            component: ColorsList,
          },
          {
            path: "editar/",
            name: "Cores - Editar",
            component: ColorsEdit,
          },
          {
            path: "criar",
            name: "Cores - Criar",
            component: ColorsCreate,
          },
        ],
      },
      {
        path: "tipocombustivel",
        name: "TipoCombustivel",
        component: TypeFuel,
        redirect: "tipocombustivel/lista",
        children: [
          {
            path: "lista",
            name: "Tipos de Combustiveis - Lista",
            component: TypeFuelList,
          },
          {
            path: "editar/",
            name: "Tipos de Combustiveis - Editar",
            component: TypeFuelEdit,
          },
          {
            path: "criar",
            name: "Tipos de Combustiveis - Criar",
            component: TypeFuelCreate,
          },
        ],
      },
      {
        path: "manufacture",
        name: "Manufacture",
        component: Manufacture,
        redirect: "manufacture/lista",
        children: [
          {
            path: "lista",
            name: "Fabricantes - Lista",
            component: ManufactureList,
          },
          {
            path: "editar/",
            name: "Fabricantes - Editar",
            component: ManufactureEdit,
          },
          {
            path: "criar",
            name: "Fabricantes - Criar",
            component: ManufactureCreate,
          },
        ],
      },
      {
        path: "medidas",
        name: "Medidas",
        component: Measure,
        redirect: "medidas/lista",
        children: [
          {
            path: "lista",
            name: "Medidas - Lista",
            component: MeasureList,
          },
          {
            path: "editar/",
            name: "Medidas - Editar",
            component: MeasureEdit,
          },
          {
            path: "criar",
            name: "Medidas - Criar",
            component: MeasureCreate,
          },
        ],
      },

      {
        path: "anuncios",
        name: "Anúncios",
        component: Car,
        redirect: "anuncios/lista",
        children: [
          {
            path: "lista",
            name: "Anúncios - Lista",
            component: CarList,
          },
          {
            path: "editar/",
            name: "Anúncios - Editar",
            component: CarEdit,
          },
          {
            path: "criar",
            name: "Anúncios - Criar",
            component: CarCreate,
          },
        ],
      },

      {
        path: "cobrancas",
        name: "Cobranças",
        component: SaleCar,
        redirect: "cobrancas/lista",
        children: [
          {
            path: "lista",
            name: "Cobranças - Lista",
            component: SaleCarList,
          },
          {
            path: "editar/",
            name: "Cobranças - Editar",
            component: SaleCarEdit,
          },
          {
            path: "criar",
            name: "Cobranças - Criar",
            component: SaleCarCreate,
          },
        ],
      },
      {
        path: "suportes",
        name: "Suportes",
        component: Support,
        redirect: "upgrades/lista",
        children: [
          {
            path: "lista",
            name: "Suportes - Lista",
            component: SupportList,
          },
          {
            path: "editar/",
            name: "Suportes - Editar",
            component: SupportEdit,
          },
          {
            path: "criar",
            name: "Suportes - Criar",
            component: SupportCreate,
          },
        ],
      },
      {
        path: "notificacoes",
        name: "Notificações",
        component: Notifications,
        redirect: "notificacoes/lista",
        children: [
          {
            path: "lista",
            name: "Notificações - Lista",
            component: NotificationList,
          },
          {
            path: "criar",
            name: "Notificações - Criar",
            component: NotificationCreate,
          },
          {
            path: "editar/:id",
            name: "Notificações - Editar",
            component: NotificationEdit,
          },
        ],
      },
      {
        path: "configuracoes",
        name: "Configurações",
        component: Settings,
        redirect: "configuracoes/editar",
        children: [
          {
            path: "editar",
            name: "Configurações",
            component: SettingsEdit,
          },
        ],
      },
      {
        path: "senha",
        name: "Senha",
        component: Password,
        redirect: "senha/editar",
        children: [
          {
            path: "editar",
            name: "Trocar Senha",
            component: PasswordEdit,
          },
        ],
      },
    ],
  },
  { path: "*", component: NotFound },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/routes.js